import React, { useState, useEffect } from "react";
import {
    bodilyInjuryLimitOptions,
    propertyDamageLimitOptions,
    personalInjuryLimitOptions,
    deductibleOptions,
} from "@/constants/selectOptions";
import { formatNumberWithCommas, uncomma } from "@/utils";

export const InsuranceInfoTotal = ({ contractInsuranceCondition, onUpdate, contractIndex, disabled = false, showToast }) => {
    const [bodilyInjuryLimitInputMode, setBodilyInjuryLimitInputMode] = useState(false);
    const [propertyDamageLimitInputMode, setPropertyDamageLimitInputMode] = useState(false);
    const [personalInjuryLimitInjuryInputMode, setPersonalInjuryLimitInjuryInputMode] = useState(false);
    const [personalInjuryLimitDeathInputMode, setPersonalInjuryLimitDeathInputMode] = useState(false);
    const [bodilyInjuryDeductibleInputMode, setBodilyInjuryDeductibleInputMode] = useState(false);
    const [propertyDamageDeductibleInputMode, setPropertyDamageDeductibleInputMode] = useState(false);
    const [personalInjuryDeductibleInputMode, setPersonalInjuryDeductibleInputMode] = useState(false);

    // 대인한도 변경 핸들러
    const handleBodilyInjuryLimitChange = (value) => {
        if (!disabled) {
            onUpdate("bodilyInjuryLimitPrice", value);
            setBodilyInjuryLimitInputMode(false);
        }
    };

    // 대인한도 직접입력 핸들러
    const handleBodilyInjuryLimitInputChange = (e) => {
        if (!disabled) {
            const value = e.target.value;
            if (value === "") {
                onUpdate("bodilyInjuryLimitPrice", null);
            } else {
                const numericValue = parseInt(uncomma(value));
                // 10억 미만으로 제한 (100,000만원)
                if (numericValue >= 100000) {
                    if (showToast) {
                        showToast("대인한도가 너무 큽니다. 10억원 미만으로 입력해주세요.");
                    }
                    return;
                }
                onUpdate("bodilyInjuryLimitPrice", numericValue * 10000); // 만원 단위를 원 단위로 변환
            }
        }
    };

    // 대물한도 변경 핸들러
    const handlePropertyDamageLimitChange = (value) => {
        if (!disabled) {
            onUpdate("propertyDamageLimitPrice", value);
            setPropertyDamageLimitInputMode(false);
        }
    };

    // 대물한도 직접입력 핸들러
    const handlePropertyDamageLimitInputChange = (e) => {
        if (!disabled) {
            const value = e.target.value;
            if (value === "") {
                onUpdate("propertyDamageLimitPrice", null);
            } else {
                const numericValue = parseInt(uncomma(value));
                // 10억 미만으로 제한 (100,000만원)
                if (numericValue >= 100000) {
                    if (showToast) {
                        showToast("대물한도가 너무 큽니다. 10억원 미만으로 입력해주세요.");
                    }
                    return;
                }
                onUpdate("propertyDamageLimitPrice", numericValue * 10000); // 만원 단위를 원 단위로 변환
            }
        }
    };

    // 자손한도(부상) 변경 핸들러
    const handlePersonalInjuryLimitInjuryChange = (value) => {
        if (!disabled) {
            onUpdate("personalInjuryLimitInjury", value);
            setPersonalInjuryLimitInjuryInputMode(false);
        }
    };

    // 자손한도(부상) 직접입력 핸들러
    const handlePersonalInjuryLimitInjuryInputChange = (e) => {
        if (!disabled) {
            const value = e.target.value;
            if (value === "") {
                onUpdate("personalInjuryLimitInjury", null);
            } else {
                const numericValue = parseInt(uncomma(value));
                // 10억 미만으로 제한 (100,000만원)
                if (numericValue >= 100000) {
                    if (showToast) {
                        showToast("자손한도(부상)가 너무 큽니다. 10억원 미만으로 입력해주세요.");
                    }
                    return;
                }
                onUpdate("personalInjuryLimitInjury", numericValue * 10000); // 만원 단위를 원 단위로 변환
            }
        }
    };

    // 자손한도(사망) 변경 핸들러
    const handlePersonalInjuryLimitDeathChange = (value) => {
        if (!disabled) {
            onUpdate("personalInjuryLimitDeath", value);
            setPersonalInjuryLimitDeathInputMode(false);
        }
    };

    // 자손한도(사망) 직접입력 핸들러
    const handlePersonalInjuryLimitDeathInputChange = (e) => {
        if (!disabled) {
            const value = e.target.value;
            if (value === "") {
                onUpdate("personalInjuryLimitDeath", null);
            } else {
                const numericValue = parseInt(uncomma(value));
                // 10억 미만으로 제한 (100,000만원)
                if (numericValue >= 100000) {
                    if (showToast) {
                        showToast("자손한도(사망)가 너무 큽니다. 10억원 미만으로 입력해주세요.");
                    }
                    return;
                }
                onUpdate("personalInjuryLimitDeath", numericValue * 10000); // 만원 단위를 원 단위로 변환
            }
        }
    };

    // 면책금 공통 핸들러
    const handleDeductibleChange = (field, value) => {
        if (!disabled) {
            onUpdate(field, value);
            // 면책금 입력 모드 끄기
            if (field === "bodilyInjuryDeductible") setBodilyInjuryDeductibleInputMode(false);
            if (field === "propertyDamageDeductible") setPropertyDamageDeductibleInputMode(false);
            if (field === "personalInjuryDeductible") setPersonalInjuryDeductibleInputMode(false);
        }
    };

    // 면책금 직접 입력 핸들러
    const handleDeductibleInputChange = (e, field) => {
        if (!disabled) {
            const value = e.target.value;
            if (value === "") {
                onUpdate(field, null);
            } else {
                const numericValue = parseInt(uncomma(value));
                // 10억 미만으로 제한 (100,000만원)
                if (numericValue >= 100000) {
                    if (showToast) {
                        let fieldName = "";
                        if (field === "bodilyInjuryDeductible") fieldName = "대인면책금(인당)";
                        else if (field === "propertyDamageDeductible") fieldName = "대물면책금";
                        else if (field === "personalInjuryDeductible") fieldName = "자손면책금";

                        showToast(`${fieldName}이 너무 큽니다. 10억원 미만으로 입력해주세요.`);
                    }
                    return;
                }
                onUpdate(field, numericValue * 10000); // 만원 단위를 원 단위로 변환
            }
        }
    };

    // 표시용 값 변환
    const getDisplayValue = (value) => {
        if (value === null) return "";
        if (value === 0) return "없음";
        if (value === -1) return "무한";
        return value ? (value / 10000).toLocaleString() : "";
    };

    // 각 항목이 선택지에 없는 값인지 확인
    const isCustomValue = (value, options) => {
        if (value === null || value === undefined) return false;
        return !options.some(option => option.value === value);
    };

    // 컴포넌트 마운트 시 초기 상태 설정
    useEffect(() => {
        if (contractInsuranceCondition?.bodilyInjuryLimitPrice) {
            setBodilyInjuryLimitInputMode(isCustomValue(contractInsuranceCondition.bodilyInjuryLimitPrice, bodilyInjuryLimitOptions));
        }
        if (contractInsuranceCondition?.propertyDamageLimitPrice) {
            setPropertyDamageLimitInputMode(isCustomValue(contractInsuranceCondition.propertyDamageLimitPrice, propertyDamageLimitOptions));
        }
        if (contractInsuranceCondition?.personalInjuryLimitInjury) {
            setPersonalInjuryLimitInjuryInputMode(isCustomValue(contractInsuranceCondition.personalInjuryLimitInjury, personalInjuryLimitOptions));
        }
        if (contractInsuranceCondition?.personalInjuryLimitDeath) {
            setPersonalInjuryLimitDeathInputMode(isCustomValue(contractInsuranceCondition.personalInjuryLimitDeath, personalInjuryLimitOptions));
        }
        if (contractInsuranceCondition?.bodilyInjuryDeductible) {
            setBodilyInjuryDeductibleInputMode(isCustomValue(contractInsuranceCondition.bodilyInjuryDeductible, deductibleOptions));
        }
        if (contractInsuranceCondition?.propertyDamageDeductible) {
            setPropertyDamageDeductibleInputMode(isCustomValue(contractInsuranceCondition.propertyDamageDeductible, deductibleOptions));
        }
        if (contractInsuranceCondition?.personalInjuryDeductible) {
            setPersonalInjuryDeductibleInputMode(isCustomValue(contractInsuranceCondition.personalInjuryDeductible, deductibleOptions));
        }
    }, [contractInsuranceCondition]);

    return (
        <>
            <div className="item-row" data-grow="3">
                <div className="row-head">
                    <span>대인한도</span>
                </div>
                <div className="row-content">
                    {disabled ? (
                        <div className="form-element">
                            <input
                                type="text"
                                placeholder="금액 입력"
                                value={getDisplayValue(contractInsuranceCondition?.bodilyInjuryLimitPrice)}
                                readOnly
                                disabled={true}
                            />
                            <span className="input-esset">만원</span>
                        </div>
                    ) : (
                        <>
                            <div className="form-element">
                                {bodilyInjuryLimitInputMode ? (
                                    <>
                                        <input
                                            type="text"
                                            placeholder="금액 입력"
                                            value={getDisplayValue(contractInsuranceCondition?.bodilyInjuryLimitPrice)}
                                            onChange={handleBodilyInjuryLimitInputChange}
                                            onInput={formatNumberWithCommas}
                                        />
                                        <span className="input-esset">만원</span>
                                    </>
                                ) : (
                                    <>
                                        {bodilyInjuryLimitOptions.map((option) => (
                                            <div key={option.value} className="radiobox">
                                                <input
                                                    type="radio"
                                                    name={`bodilyInjuryLimit_${contractIndex}`}
                                                    id={`bodilyInjuryLimit_${option.value}_${contractIndex}`}
                                                    checked={contractInsuranceCondition?.bodilyInjuryLimitPrice === option.value}
                                                    onChange={() => handleBodilyInjuryLimitChange(option.value)}
                                                />
                                                <label htmlFor={`bodilyInjuryLimit_${option.value}_${contractIndex}`}>
                                                    {option.label}
                                                </label>
                                            </div>
                                        ))}
                                    </>
                                )}
                            </div>
                            <button
                                type="button"
                                className="btn btn-xs btn-outline"
                                onClick={() => setBodilyInjuryLimitInputMode(!bodilyInjuryLimitInputMode)}
                                style={{ flexShrink: 0 }}
                            >
                                {bodilyInjuryLimitInputMode ? "선택지로" : "직접입력"}
                            </button>
                        </>
                    )}
                </div>
            </div>
            <div className="item-row" data-grow="3"></div>
            <div className="item-row" data-grow="3"></div>

            <div className="item-row" data-grow="3">
                <div className="row-head">
                    <span>대물한도</span>
                </div>
                <div className="row-content">
                    {disabled ? (
                        <div className="form-element">
                            <input
                                type="text"
                                placeholder="금액 입력"
                                value={getDisplayValue(contractInsuranceCondition?.propertyDamageLimitPrice)}
                                readOnly
                                disabled={true}
                            />
                            <span className="input-esset">만원</span>
                        </div>
                    ) : (
                        <>
                            <div className="form-element">
                                {propertyDamageLimitInputMode ? (
                                    <>
                                        <input
                                            type="text"
                                            placeholder="금액 입력"
                                            value={getDisplayValue(contractInsuranceCondition?.propertyDamageLimitPrice)}
                                            onChange={handlePropertyDamageLimitInputChange}
                                            onInput={formatNumberWithCommas}
                                        />
                                        <span className="input-esset">만원</span>
                                    </>
                                ) : (
                                    <>
                                        {propertyDamageLimitOptions.map((option) => (
                                            <div key={option.value} className="radiobox">
                                                <input
                                                    type="radio"
                                                    name={`propertyDamageLimit_${contractIndex}`}
                                                    id={`propertyDamageLimit_${option.value}_${contractIndex}`}
                                                    checked={contractInsuranceCondition?.propertyDamageLimitPrice === option.value}
                                                    onChange={() => handlePropertyDamageLimitChange(option.value)}
                                                />
                                                <label htmlFor={`propertyDamageLimit_${option.value}_${contractIndex}`}>
                                                    {option.label}
                                                </label>
                                            </div>
                                        ))}
                                    </>
                                )}
                            </div>
                            <button
                                type="button"
                                className="btn btn-xs btn-outline"
                                onClick={() => setPropertyDamageLimitInputMode(!propertyDamageLimitInputMode)}
                                style={{ flexShrink: 0 }}
                            >
                                {propertyDamageLimitInputMode ? "선택지로" : "직접입력"}
                            </button>
                        </>
                    )}
                </div>
            </div>
            <div className="item-row" data-grow="3"></div>
            <div className="item-row" data-grow="3"></div>

            <div className="item-row" data-grow="3">
                <div className="row-head">
                    <span>자손한도(부상)</span>
                </div>
                <div className="row-content">
                    {disabled ? (
                        <div className="form-element">
                            <input
                                type="text"
                                placeholder="금액 입력"
                                value={getDisplayValue(contractInsuranceCondition?.personalInjuryLimitInjury)}
                                readOnly
                                disabled={true}
                            />
                            <span className="input-esset">만원</span>
                        </div>
                    ) : (
                        <>
                            <div className="form-element">
                                {personalInjuryLimitInjuryInputMode ? (
                                    <>
                                        <input
                                            type="text"
                                            placeholder="금액 입력"
                                            value={getDisplayValue(contractInsuranceCondition?.personalInjuryLimitInjury)}
                                            onChange={handlePersonalInjuryLimitInjuryInputChange}
                                            onInput={formatNumberWithCommas}
                                        />
                                        <span className="input-esset">만원</span>
                                    </>
                                ) : (
                                    <>
                                        {personalInjuryLimitOptions.map((option) => (
                                            <div key={option.value} className="radiobox">
                                                <input
                                                    type="radio"
                                                    name={`personalInjuryLimitInjury_${contractIndex}`}
                                                    id={`personalInjuryLimitInjury_${option.value}_${contractIndex}`}
                                                    checked={contractInsuranceCondition?.personalInjuryLimitInjury === option.value}
                                                    onChange={() => handlePersonalInjuryLimitInjuryChange(option.value)}
                                                />
                                                <label htmlFor={`personalInjuryLimitInjury_${option.value}_${contractIndex}`}>
                                                    {option.label}
                                                </label>
                                            </div>
                                        ))}
                                    </>
                                )}
                            </div>
                            <button
                                type="button"
                                className="btn btn-xs btn-outline"
                                onClick={() => setPersonalInjuryLimitInjuryInputMode(!personalInjuryLimitInjuryInputMode)}
                                style={{ flexShrink: 0 }}
                            >
                                {personalInjuryLimitInjuryInputMode ? "선택지로" : "직접입력"}
                            </button>
                        </>
                    )}
                </div>
            </div>
            <div className="item-row" data-grow="3"></div>
            <div className="item-row" data-grow="3"></div>

            <div className="item-row" data-grow="3">
                <div className="row-head">
                    <span>자손한도(사망)</span>
                </div>
                <div className="row-content">
                    {disabled ? (
                        <div className="form-element">
                            <input
                                type="text"
                                placeholder="금액 입력"
                                value={getDisplayValue(contractInsuranceCondition?.personalInjuryLimitDeath)}
                                readOnly
                                disabled={true}
                            />
                            <span className="input-esset">만원</span>
                        </div>
                    ) : (
                        <>
                            <div className="form-element">
                                {personalInjuryLimitDeathInputMode ? (
                                    <>
                                        <input
                                            type="text"
                                            placeholder="금액 입력"
                                            value={getDisplayValue(contractInsuranceCondition?.personalInjuryLimitDeath)}
                                            onChange={handlePersonalInjuryLimitDeathInputChange}
                                            onInput={formatNumberWithCommas}
                                        />
                                        <span className="input-esset">만원</span>
                                    </>
                                ) : (
                                    <>
                                        {personalInjuryLimitOptions.map((option) => (
                                            <div key={option.value} className="radiobox">
                                                <input
                                                    type="radio"
                                                    name={`personalInjuryLimitDeath_${contractIndex}`}
                                                    id={`personalInjuryLimitDeath_${option.value}_${contractIndex}`}
                                                    checked={contractInsuranceCondition?.personalInjuryLimitDeath === option.value}
                                                    onChange={() => handlePersonalInjuryLimitDeathChange(option.value)}
                                                />
                                                <label htmlFor={`personalInjuryLimitDeath_${option.value}_${contractIndex}`}>
                                                    {option.label}
                                                </label>
                                            </div>
                                        ))}
                                    </>
                                )}
                            </div>
                            <button
                                type="button"
                                className="btn btn-xs btn-outline"
                                onClick={() => setPersonalInjuryLimitDeathInputMode(!personalInjuryLimitDeathInputMode)}
                                style={{ flexShrink: 0 }}
                            >
                                {personalInjuryLimitDeathInputMode ? "선택지로" : "직접입력"}
                            </button>
                        </>
                    )}
                </div>
            </div>
            <div className="item-row" data-grow="3"></div>
            <div className="item-row" data-grow="3"></div>

            <div className="item-row" data-grow="3">
                <div className="row-head">
                    <span>대인면책금(인당)</span>
                </div>
                <div className="row-content">
                    {disabled ? (
                        <div className="form-element">
                            <input
                                type="text"
                                placeholder="금액 입력"
                                value={getDisplayValue(contractInsuranceCondition?.bodilyInjuryDeductible)}
                                readOnly
                                disabled={true}
                            />
                            <span className="input-esset">만원</span>
                        </div>
                    ) : (
                        <>
                            <div className="form-element">
                                {bodilyInjuryDeductibleInputMode ? (
                                    <>
                                        <input
                                            type="text"
                                            placeholder="금액 입력"
                                            value={getDisplayValue(contractInsuranceCondition?.bodilyInjuryDeductible)}
                                            onChange={(e) => handleDeductibleInputChange(e, "bodilyInjuryDeductible")}
                                            onInput={formatNumberWithCommas}
                                        />
                                        <span className="input-esset">만원</span>
                                    </>
                                ) : (
                                    <>
                                        {deductibleOptions.map((option) => (
                                            <div key={option.value || "none"} className="radiobox">
                                                <input
                                                    type="radio"
                                                    name={`bodilyInjuryDeductible_${contractIndex}`}
                                                    id={`bodilyInjuryDeductible_${option.value || "none"}_${contractIndex}`}
                                                    checked={contractInsuranceCondition?.bodilyInjuryDeductible === option.value}
                                                    onChange={() => handleDeductibleChange("bodilyInjuryDeductible", option.value)}
                                                />
                                                <label htmlFor={`bodilyInjuryDeductible_${option.value || "none"}_${contractIndex}`}>
                                                    {option.label}
                                                </label>
                                            </div>
                                        ))}
                                    </>
                                )}
                            </div>
                            <button
                                type="button"
                                className="btn btn-xs btn-outline"
                                onClick={() => setBodilyInjuryDeductibleInputMode(!bodilyInjuryDeductibleInputMode)}
                                style={{ flexShrink: 0 }}
                            >
                                {bodilyInjuryDeductibleInputMode ? "선택지로" : "직접입력"}
                            </button>
                        </>
                    )}
                </div>
            </div>
            <div className="item-row" data-grow="3"></div>
            <div className="item-row" data-grow="3"></div>

            <div className="item-row" data-grow="3">
                <div className="row-head">
                    <span>대물면책금</span>
                </div>
                <div className="row-content">
                    {disabled ? (
                        <div className="form-element">
                            <input
                                type="text"
                                placeholder="금액 입력"
                                value={getDisplayValue(contractInsuranceCondition?.propertyDamageDeductible)}
                                readOnly
                                disabled={true}
                            />
                            <span className="input-esset">만원</span>
                        </div>
                    ) : (
                        <>
                            <div className="form-element">
                                {propertyDamageDeductibleInputMode ? (
                                    <>
                                        <input
                                            type="text"
                                            placeholder="금액 입력"
                                            value={getDisplayValue(contractInsuranceCondition?.propertyDamageDeductible)}
                                            onChange={(e) => handleDeductibleInputChange(e, "propertyDamageDeductible")}
                                            onInput={formatNumberWithCommas}
                                        />
                                        <span className="input-esset">만원</span>
                                    </>
                                ) : (
                                    <>
                                        {deductibleOptions.map((option) => (
                                            <div key={option.value || "none"} className="radiobox">
                                                <input
                                                    type="radio"
                                                    name={`propertyDamageDeductible_${contractIndex}`}
                                                    id={`propertyDamageDeductible_${option.value || "none"}_${contractIndex}`}
                                                    checked={contractInsuranceCondition?.propertyDamageDeductible === option.value}
                                                    onChange={() => handleDeductibleChange("propertyDamageDeductible", option.value)}
                                                />
                                                <label htmlFor={`propertyDamageDeductible_${option.value || "none"}_${contractIndex}`}>
                                                    {option.label}
                                                </label>
                                            </div>
                                        ))}
                                    </>
                                )}
                            </div>
                            <button
                                type="button"
                                className="btn btn-xs btn-outline"
                                onClick={() => setPropertyDamageDeductibleInputMode(!propertyDamageDeductibleInputMode)}
                                style={{ flexShrink: 0 }}
                            >
                                {propertyDamageDeductibleInputMode ? "선택지로" : "직접입력"}
                            </button>
                        </>
                    )}
                </div>
            </div>
            <div className="item-row" data-grow="3"></div>
            <div className="item-row" data-grow="3"></div>

            <div className="item-row" data-grow="3">
                <div className="row-head">
                    <span>자손면책금</span>
                </div>
                <div className="row-content">
                    {disabled ? (
                        <div className="form-element">
                            <input
                                type="text"
                                placeholder="금액 입력"
                                value={getDisplayValue(contractInsuranceCondition?.personalInjuryDeductible)}
                                readOnly
                                disabled={true}
                            />
                            <span className="input-esset">만원</span>
                        </div>
                    ) : (
                        <>
                            <div className="form-element">
                                {personalInjuryDeductibleInputMode ? (
                                    <>
                                        <input
                                            type="text"
                                            placeholder="금액 입력"
                                            value={getDisplayValue(contractInsuranceCondition?.personalInjuryDeductible)}
                                            onChange={(e) => handleDeductibleInputChange(e, "personalInjuryDeductible")}
                                            onInput={formatNumberWithCommas}
                                        />
                                        <span className="input-esset">만원</span>
                                    </>
                                ) : (
                                    <>
                                        {deductibleOptions.map((option) => (
                                            <div key={option.value || "none"} className="radiobox">
                                                <input
                                                    type="radio"
                                                    name={`personalInjuryDeductible_${contractIndex}`}
                                                    id={`personalInjuryDeductible_${option.value || "none"}_${contractIndex}`}
                                                    checked={contractInsuranceCondition?.personalInjuryDeductible === option.value}
                                                    onChange={() => handleDeductibleChange("personalInjuryDeductible", option.value)}
                                                />
                                                <label htmlFor={`personalInjuryDeductible_${option.value || "none"}_${contractIndex}`}>
                                                    {option.label}
                                                </label>
                                            </div>
                                        ))}
                                    </>
                                )}
                            </div>
                            <button
                                type="button"
                                className="btn btn-xs btn-outline"
                                onClick={() => setPersonalInjuryDeductibleInputMode(!personalInjuryDeductibleInputMode)}
                                style={{ flexShrink: 0 }}
                            >
                                {personalInjuryDeductibleInputMode ? "선택지로" : "직접입력"}
                            </button>
                        </>
                    )}
                </div>
            </div>
            <div className="item-row" data-grow="3"></div>
            <div className="item-row" data-grow="3"></div>
        </>
    );
};
